export const labDialogCopy={
 ja:{title:'実験室',description:'値を変えて仕組みを観察します。閉じると読んでいた場所へ戻ります。',close:'実験を閉じて読む',shortcut:'Escで閉じる'},
 en:{title:'Experiment room',description:'Change the controls to inspect the mechanism. Close the experiment to return to your reading.',close:'Close and return to reading',shortcut:'Esc to close'}
};
